module.exports = __webpack_public_path__ + "static/media/philantropic.595794de.svg";